import { useState, useEffect } from "react";
import moment from "moment";
// material
import {
  Box,
  Card,
  Typography,
  TableCell,
  TableBody,
  TableContainer,
  Table,
  TableRow,
} from "@mui/material";
// components
import {
  Log,
  sendDataWithPost,
} from "../../services/services";

import ListHead from "../../components/table/ListHead";
import Scrollbar from "../../components/table/Scrollbar";
import { applySortFilter } from "../../utils/tableFunctions";
import { StyledTableRow } from "../../components/TableRow";

import CircularLoader from "../../components/circularLoader";
import { CustomTableCell } from "../../components/TableCell";
import { useLoadingSpinnerContext } from "../../context/loadingSpinnerContext";
import Label from "../../components/Label";
import Pagination from "../../components/Pagination";
import { pageNumber, rowsPerPage } from "../../utils/constants";
import CommonDialog from "../../components/CustomDialog";
import HeaderHelpPage from "../../components/HeaderHelpPage";
import BankAccountDetails from "./Dialogs/BankAccountDetail";

// ----------------------------------------------------------------------

const defaultValue = {};

const TABLE_HEAD = [
  { id: "account_number", label: "Account Number" },
  { id: "account_name", label: "Account Name" },
  { id: "bank", label: "Bank Name" },
  { id: "created_at", label: "Created At" },
  { id: "created_by", label: "Created By" },
  { id: "approved_by", label: "Approved By" },
  { id: "action", label: "Action" },
  { id: "approved", label: "Approved" },
];

export default function HistoryBankAccount() {
  const { setGlobalLoading } = useLoadingSpinnerContext();
  const [loaded, setLoaded] = useState(false);
  const [tableData, setTableData] = useState({
    results: [],
  });
  const [filter, setFilter] = useState({});
  const [itemId, setItemId] = useState(null);

  const [pagination, setPagination] = useState({ page: pageNumber, page_size: rowsPerPage });

  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("name");

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    queryPage(
      {
        page: newPage + 1,
        page_size: pagination.page_size,
      },
      filter
    );
  };

  const handleChangeRowsPerPage = (event) => {
    queryPage(
      {
        page: 1,
        page_size: event.target.value,
      },
      filter
    );
  };

  const renderData = (res) => {
    const newData = res.results.map((item) => ({
      ...item,
      approved: (
        <>
          <Label variant="ghost" color={item?.approved_by ? "success" : "error"}>
            {item?.approved_by ? "YES" : "NO"}
          </Label>
        </>
      ),
    }));

    setTableData({
      ...res,
      results: newData,
    });
  };

  const queryPage = (params, filter) => {
    loaded && setLoaded(false);
    const queryParams = new URLSearchParams(params || pagination).toString();
    const url = `/bank_account/bank_account_pending/filter_history/?${queryParams}`;
    sendDataWithPost(url, filter, renderData, setLoaded, () => {
      params && setPagination(params);
    });
  };

  const onFilterSubmit = (fParams) => {
    const newPrams = {
      ...fParams,
    };

    const newPagination = {
      ...pagination,
      page: 1,
    };

    Log.info("Search History Bank Account", newPrams);
    setFilter(newPrams);
    queryPage(newPagination, newPrams);
  };

  useEffect(() => {
    onFilterSubmit(defaultValue);
  }, []);

  const dataNotFound = tableData?.results?.length === 0;

  const filteredList = applySortFilter(
    tableData?.results || [],
    order,
    orderBy
  );

  return (
    <Box>
      {loaded ? (
        <Card>
          <Scrollbar>
            <TableContainer>
              <Table>
                <ListHead
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={handleRequestSort}
                  headLabel={TABLE_HEAD}
                  checkbox={false}
                />
                <TableBody>
                  {filteredList?.map((row, i) => {
                    const {
                      account_number,
                      bank,
                      account_name,
                      created_at,
                      created_by,
                      approved_by,
                      action,
                      approved,
                    } = row;
                      
                    return (
                      <StyledTableRow
                        hover
                        key={i}
                        onClick={() => setItemId(row.id)}
                        sx={{ cursor: "pointer" }}
                      >
                        <CustomTableCell field={account_number} />
                        <CustomTableCell field={account_name} />
                        <CustomTableCell field={bank} />
                        <CustomTableCell field={moment(created_at).format("DD-MM-YYYY HH:mm")} />
                        <CustomTableCell field={created_by?.email} />
                        <CustomTableCell field={approved_by?.email} />
                        <CustomTableCell field={action} />
                        <CustomTableCell field={approved} />
                      </StyledTableRow>
                    );
                  })}
                </TableBody>
                {dataNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={9} sx={{ py: 3 }}>
                        <Typography
                          gutterBottom
                          align="center"
                          variant="subtitle1"
                        >
                          Not found
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>
          {tableData?.results?.length > 0 && (
            <Pagination
              count={tableData.count}
              pagination={pagination}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
        </Card>
      ) : (
        <CircularLoader />
      )}

      {itemId && (
        <CommonDialog
          title={<HeaderHelpPage title="Bank Account Details" variant="h5" mb={0} />}
          onClose={() => setItemId(null)}
        >
          <BankAccountDetails itemId={itemId} isViewHistory />
        </CommonDialog>
      )}
    </Box>
  );
}
